// Press list. Honest. No fake mentions. Editable.
export const PRESS = [
  // DEV NOTE: Add real press features here when available.
  // Example shape:
  // { slug, outlet, headline, url, date }
];
